import React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {notify} from 'react-notify-toast'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
require('firebase/storage')


class PostsForm extends React.Component {

  constructor () {
    super()
    this.state = {
      title: '',
      desc: '',
      uploadValue: 0,
      fileUrl: null,
      file: null,
      type: 'news',
      people: 0,
      startDate: moment(),
      endDate: moment(),
      sessions: []
    }

    this.handleOnChange               = this.handleOnChange.bind(this)
    this.handleTitle                  = this.handleTitle.bind(this)
    this.handleDesc                   = this.handleDesc.bind(this)
    this.save                         = this.save.bind(this)
    this.handlePeople                 = this.handlePeople.bind(this)
    this.handleType                   = this.handleType.bind(this)
    this.storePost                    = this.storePost.bind(this)
    this.addSession                   = this.addSession.bind(this)
    this.handleChangeStartDatePicker  = this.handleChangeStartDatePicker.bind(this)
    this.handleChangeEndDatePicker    = this.handleChangeEndDatePicker.bind(this)
    this.removeSession                = this.removeSession.bind(this)
    this.cancel                       = this.cancel.bind(this)
    this.initForm                     = this.initForm.bind(this)
  }

  render() {


    console.log('render sessions!')
    console.log(this.state.sessions)

    return (
      <div className="newsFormDiv">
        Tipo:
        <br/>
        <select className="form-control newsInput" ref="type"
          value={this.state.type}
          onChange={this.handleType}>
          <option value="news">Noticia</option>
          <option value="course">Curso</option>
        </select>

        { this.state.type==='course' ? 
          <div className="row">
            <div className="col-md-4">
              Plazas:
              <br/>
              <input className="form-control newsInput" 
                  value={this.state.people}
                  onChange={this.handlePeople}
                  pattern="[0-9]*"
                  maxLength="2"
                  size="2"
                  ref="people" type="text" />
            </div>
            <div className="col-md-8">
              Añadir sesión:
              <br/>
              Inicio:<br/>
              <DatePicker
                  selected={this.state.startDate}
                  onChange={this.handleChangeStartDatePicker}
                  locale="es"
                  dateFormat="DD/MM/YYYY HH:mm"
                  className="form-control dateInput floatRight"
                  showTimeSelect
                  size="4"
                  timeFormat="HH:mm"
                  timeIntervals={30}                
                  /> 
              <br/>
              Fin:<br/>
              <DatePicker
                  selected={this.state.endDate}
                  onChange={this.handleChangeEndDatePicker}
                  locale="es"
                  dateFormat="DD/MM/YYYY HH:mm"
                  className="form-control dateInput floatRight"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={30}                
                  /> 
              
              <br/>
              <button className='btn btn-lignht btn-sm floatRight' onClick={this.addSession}>Añadir</button>

            </div>
          </div>
        : null }

        { this.state.type==='course' &&
          this.state.sessions.length>0?
            <div className="sessionsDiv">
              Sessiones:
              <br/>
              {
                this.state.sessions.map ( (session, i) => {
                  return (
                    <div key="index">
                      {i+1}. {session.startDate} {session.startTime} - {session.endDate} {session.endTime}
                      &nbsp;&nbsp;
                      <i className="material-icons btnIconSmall" title="Eliminar" onClick={()=>this.removeSession(session)}>delete</i>
                    </div>
                  )
                })
              }
              <br/>
            </div>
          : null
        }

        Título:
        <br/>
        <input className="form-control newsInput" 
            value={this.state.title}
            onChange={this.handleTitle}
            ref="title" type="text" placeholder="título de noticia/curso ..." />
        
        Descripción:
        <br/>
        <textarea className="form-control newsTextarea" id="desc" ref="desc" name="desc" rows="10"
              maxLength="1024"
              value={this.state.desc}
              onChange={this.handleDesc}></textarea>

        Selecciona imagen:
        <br />
        <input type='file' ref='uploadInput' onChange={this.handleOnChange}/>
        <br />
        <br />
        <button className='btn btn-lignht btn-sm floatRight' onClick={this.save}>Guardar</button>
        <button className='btn btn-lignht btn-sm floatRight' onClick={this.cancel}>Cancelar</button>

        { this.state.uploadValue>0 ?
          <center>
            <progress value={this.state.uploadValue} max='100'>
              {this.state.uploadValue} %
            </progress>
          </center>
          : null
        }
        <br/>
        <br/>
        
      </div>
    )
  }

  componentDidMount () {
    this.loadPostEdition (this.props)
  }

  componentWillReceiveProps(props) {
    this.loadPostEdition (props)
  }

  initForm () {
    this.setState({
      title: '',
      desc: '',
      uploadValue: 0,
      fileUrl: null,
      file: null,
      type: 'news',
      people: 0,
      startDate: moment(),
      endDate: moment(),
      sessions: []
    })
  }

  cancel () {
    this.initForm()
    this.props.backToNews()    
  }

  loadPostEdition (props) {
    if ( props.postToEdit!==null ) {
      let sessions = []
      if ( props.postToEdit.sessions!==undefined ) {        
        Object.keys(props.postToEdit.sessions).map ( ses => {
            const s = props.postToEdit.sessions[ses]
            sessions.push ( s )
        })
      }
      
      let people = props.postToEdit.people
      if ( people===undefined ) {
        people = null
      }
      this.setState({
        postToEdit: props.postToEdit,
        type: props.postToEdit.type,
        title: props.postToEdit.title,
        desc: props.postToEdit.desc,
        people: people,
        sessions: sessions
      })
    }
  }

  handleChangeStartDatePicker (value) {
    this.setState({
      startDate: value,
      endDate: moment(value).add(2, "hours")
    })
  }

  handleChangeEndDatePicker (value) {
    this.setState({
      endDate: value
    })
  }

  addSession () {

    if ( (this.state.startDate.diff(this.state.endDate) === 0) || (this.state.startDate.diff(this.state.endDate) > 0) ) {
      notify.show ('Selecciona un periodo coherente de fechas', 'error', 1250)
    }

    let sessions = this.state.sessions
    sessions.push({
      startDate: this.state.startDate.format('DD/MM/YYYY'),
      startTime: this.state.startDate.format('HH:mm'),
      endDate: this.state.endDate.format('DD/MM/YYYY'),
      endTime: this.state.endDate.format('HH:mm')
    })

    this.setState({
      sessions: sessions
    })

  }

  handlePeople (event) {
    if (event.target.validity.valid) {
      this.setState({
        people: this.refs.people.value
      })
    }
  }

  handleType() {
    this.setState({
      type: this.refs.type.value
    })
  }

  handleTitle () {
    this.setState({
      title: this.refs.title.value
    })
  }

  handleDesc () {
    this.setState({
      desc: this.refs.desc.value
    })
  }

  handleOnChange (event) {

    const file = event.target.files[0]

    if ( file.type===undefined || !file.type.toString().startsWith('image') ) {
      alert('El archivo seleccionado no es una imagen ('+file.type+')')
      this.refs.uploadInput.value = ''
    } else {
      this.setState({
        file: file
      })
    }

  }

  save () {

    if ( this.refs.type.value==='course' && (this.refs.people.value==='0' || this.refs.people.value==='') ) {
      notify.show ('Introduce número de plazas', 'error', 1250)
      return false
    }
    if ( this.refs.title.value.trim()==='' ) {
      notify.show ('Introduce título', 'error', 1250)
      return false
    }
    if ( this.refs.desc.value.trim()==='' ) {
      notify.show ('Introduce descripción', 'error', 1250)
      return false
    }

    if ( this.state.file!==null ) {

      const imgRef = 'pics/' + this.state.file.name
      const storageRef = firebase.storage().ref(imgRef)
      const task = storageRef.put(this.state.file)

      // TODO: validate image name, don't overwrite images!!

      task.on('state_changed', (snapshot) => {
        let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        this.setState({
          uploadValue: percentage
        })
      }, (error) => {
        console.error(error.message)
      }, () => {
        // Upload complete        
        firebase.storage().ref(task.location_.path_).getDownloadURL().then ( url => {
          this.setState({
            fileUrl: url
          })

          this.storePost(imgRef, url)
        })      
      })

    } else {
      this.storePost('', '')
    }

  }

  storePost (imgRef, url) {

    let stateSessions = this.state.sessions

    let newPost = {
      type: this.refs.type.value,
      title: this.refs.title.value.trim(),
      desc: this.refs.desc.value.trim(),
      imageRef: imgRef,
      imageUrl: url,
      creationDate: new moment().format('DD/MM/YYYY HH:mm'),
      sessions: []
    }

    if ( this.props.postToEdit!==null && imgRef==='') {
      newPost.imageRef = this.props.postToEdit.imageRef
      newPost.imageUrl = this.props.postToEdit.imageUrl
    }

    if ( newPost.type==='course' ) {
      newPost.people = this.refs.people.value
    }

    if ( this.props.postToEdit===null ) {
      firebase.database().ref("posts").push(newPost).then ( snap => {

        if ( newPost.type==='course' ) {
          this.state.sessions.forEach ( s => {
            firebase.database().ref("posts").child(snap.key).child("sessions").push (s)
          })
        }

        this.refs.type.value = 'news'
        if ( this.refs.people ) {
          this.refs.people.value = '0'
        }
        this.refs.title.value = ''
        this.refs.desc.value = ''
        notify.show ('Nueva noticia/curso guardado', 'success', 1250)
        this.setState({
          title: '',
          desc: '',
          uploadValue: 0,
          fileUrl: null,
          file: null,
          type: 'news',
          people: 0,
          startDate: moment(),
          endDate: moment(),
          sessions: []
        })
        this.props.backToNews()
        this.initForm()
      })
    } else {

      firebase.database().ref("posts").child( this.props.postToEdit.key ).update(newPost).then ( snap => {

        if ( newPost.type==='course' ) {
          stateSessions.forEach ( s => {
            firebase.database().ref("posts").child(this.props.postToEdit.key).child("sessions").push (s)
          })
        }

        this.refs.type.value = 'news'
        if ( this.refs.people ) {
          this.refs.people.value = '0'
        }
        this.refs.title.value = ''
        this.refs.desc.value = ''
        notify.show ('Datos actualizados', 'success', 1250)
        this.setState({
          title: '',
          desc: '',
          uploadValue: 0,
          fileUrl: null,
          file: null,
          type: 'news',
          people: 0,
          startDate: moment(),
          endDate: moment(),
          sessions: []
        })
      })
    }
  }

  removeSession (session) {
    let sessions = this.state.sessions
    sessions.splice( this.state.sessions.indexOf(session), 1)
    this.setState({
      sessions: sessions
    })
  }
}

export default PostsForm
